(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/namnsdagar.js') >= 0) return;  svs.modules.push('/modules/tickets-giftshop/assets/react/pages/gift/components/gift-form/components/date-selector/namnsdagar.js');
"use strict";


const namesByDateData = {
  namesByDate: {
    1: {
      1: ['Nyårsdagen (ingen namnsdag)'],
      2: ['Svea'],
      3: ['Alfred', 'Alfrida'],
      4: ['Rut'],
      5: ['Hanna', 'Hannele'],
      6: ['Baltsar', 'Kasper', 'Melker'],
      7: ['August', 'Augusta'],
      8: ['Erland'],
      9: ['Gunder', 'Gunnar'],
      10: ['Sigbritt', 'Sigurd'],
      11: ['Jan', 'Jannike'],
      12: ['Frideborg', 'Fridolf'],
      13: ['Knut'],
      14: ['Felicia', 'Felix'],
      15: ['Laura', 'Lorentz'],
      16: ['Helmer', 'Hjalmar'],
      17: ['Anton', 'Tony'],
      18: ['Hilda', 'Hildur'],
      19: ['Henrik', 'Henry'],
      20: ['Fabian', 'Sebastian'],
      21: ['Agnes', 'Agneta'],
      22: ['Viktor', 'Vincent'],
      23: ['Frej', 'Freja'],
      24: ['Erika'],
      25: ['Paul', 'Pål'],
      26: ['Bodil', 'Boel'],
      27: ['Göta', 'Göte'],
      28: ['Karl', 'Karla'],
      29: ['Diana'],
      30: ['Gunhild', 'Gunilla'],
      31: ['Ivar', 'Joar']
    },
    2: {
      1: ['Max', 'Maximilian'],
      2: ['Kyndelsmässodagen (ingen namnsdag)'],
      3: ['Disa', 'Hjördis'],
      4: ['Anselm', 'Ansgar'],
      5: ['Agata', 'Agda'],
      6: ['Doris', 'Dorotea'],
      7: ['Dick', 'Rikard'],
      8: ['Bert', 'Berta'],
      9: ['Fanny', 'Franciska'],
      10: ['Iris'],
      11: ['Inge', 'Yngve'],
      12: ['Evelina', 'Evelyn', 'Evy'],
      13: ['Agne', 'Ove'],
      14: ['Valentin'],
      15: ['Sigfrid'],
      16: ['Julia', 'Julius'],
      17: ['Alexandra', 'Sandra'],
      18: ['Frida', 'Fritiof'],
      19: ['Ella', 'Gabriella'],
      20: ['Vivianne'],
      21: ['Hilding'],
      22: ['Pia'],
      23: ['Torsten', 'Torun'],
      24: ['Mats', 'Mattias'],
      25: ['Sigvard', 'Sivert'],
      26: ['Torgny', 'Torkel'],
      27: ['Lage'],
      28: ['Maja', 'Maria'],
      29: ['Skottdagen (ingen namnsdag)']
    },
    3: {
      1: ['Albin', 'Elvira'],
      2: ['Erna', 'Ernst'],
      3: ['Gunborg', 'Gunvor'],
      4: ['Adrian', 'Adriana'],
      5: ['Tora', 'Tove'],
      6: ['Ebba', 'Ebbe'],
      7: ['Camilla'],
      8: ['Saga', 'Siv'],
      9: ['Torbjörn', 'Torleif'],
      10: ['Ada', 'Edla'],
      11: ['Edvin', 'Egon'],
      12: ['Regina', 'Viktoria'],
      13: ['Greger'],
      14: ['Matilda', 'Maud'],
      15: ['Christel', 'Kristoffer'],
      16: ['Gilbert', 'Herbert'],
      17: ['Gertrud'],
      18: ['Edmund', 'Edvard'],
      19: ['Josef', 'Josefina'],
      20: ['Joakim', 'Kim'],
      21: ['Bengt'],
      22: ['Kennet', 'Kent'],
      23: ['Gerd', 'Gerda'],
      24: ['Gabriel', 'Rafael'],
      25: ['Marie bebådelsedag (ingen namnsdag)'],
      26: ['Emanuel'],
      27: ['Ralf', 'Rudolf'],
      28: ['Malkolm', 'Morgan'],
      29: ['Jens', 'Jonas'],
      30: ['Holger', 'Holmfrid'],
      31: ['Ester', 'Noa']
    },
    4: {
      1: ['Harald', 'Hervor'],
      2: ['Gudmund', 'Ingemund'],
      3: ['Ferdinand', 'Nanna'],
      4: ['Marianne', 'Marlene'],
      5: ['Irene', 'Irja'],
      6: ['Vilhelm', 'William'],
      7: ['Irma', 'Irmelin'],
      8: ['Nadja', 'Tanja'],
      9: ['Ottilia', 'Otto'],
      10: ['Ingvar', 'Ingvor'],
      11: ['Ulf', 'Ylva'],
      12: ['Liv'],
      13: ['Artur', 'Douglas'],
      14: ['Tiburtius'],
      15: ['Oliver', 'Olivia'],
      16: ['Patricia', 'Patrik'],
      17: ['Elias', 'Elis'],
      18: ['Valdemar', 'Volmar'],
      19: ['Ola', 'Olaus'],
      20: ['Amalia', 'Amelie'],
      21: ['Anneli', 'Annika'],
      22: ['Allan', 'Glenn'],
      23: ['Georg', 'Göran'],
      24: ['Vega'],
      25: ['Markus'],
      26: ['Terese', 'Teresia'],
      27: ['Engelbrekt'],
      28: ['Ture', 'Tyra'],
      29: ['Tyko'],
      30: ['Mariana']
    },
    5: {
      1: ['Valborg'],
      2: ['Filip', 'Filippa'],
      3: ['Jane', 'John'],
      4: ['Mona', 'Monika'],
      5: ['Erhard', 'Gotthard'],
      6: ['Marit', 'Rita'],
      7: ['Carina', 'Carita'],
      8: ['Åke'],
      9: ['Reidar', 'Reidun'],
      10: ['Esbjörn', 'Styrbjörn'],
      11: ['Märit', 'Märta'],
      12: ['Charlotta', 'Lotta'],
      13: ['Linn', 'Linnea'],
      14: ['Halvar', 'Halvard'],
      15: ['Sofia', 'Sonja'],
      16: ['Ronald', 'Ronny'],
      17: ['Rebecka', 'Ruben'],
      18: ['Erik'],
      19: ['Maj', 'Majken'],
      20: ['Carola', 'Karolina'],
      21: ['Conny', 'Konstantin'],
      22: ['Hemming', 'Henning'],
      23: ['Desideria', 'Desirée'],
      24: ['Ivan', 'Vanja'],
      25: ['Urban'],
      26: ['Vilhelmina', 'Vilma'],
      27: ['Beda', 'Blenda'],
      28: ['Borghild', 'Ingeborg'],
      29: ['Jeanette', 'Yvonne'],
      30: ['Vera', 'Veronika'],
      31: ['Pernilla', 'Petronella']
    },
    6: {
      1: ['Gun', 'Gunnel'],
      2: ['Roger', 'Rutger'],
      3: ['Gudmar', 'Ingemar'],
      4: ['Solbritt', 'Solveig'],
      5: ['Bo'],
      6: ['Gustav', 'Gösta'],
      7: ['Robert', 'Robin'],
      8: ['Eivor', 'Majvor'],
      9: ['Birger', 'Börje'],
      10: ['Boris', 'Svante'],
      11: ['Berthold', 'Bertil'],
      12: ['Eskil'],
      13: ['Aina', 'Aino'],
      14: ['Hakon', 'Håkan'],
      15: ['Margit', 'Margot'],
      16: ['Axel', 'Axelina'],
      17: ['Torborg', 'Torvald'],
      18: ['Bjarne', 'Björn'],
      19: ['Germund', 'Görel'],
      20: ['Linda'],
      21: ['Alf', 'Alvar'],
      22: ['Paula', 'Paulina'],
      23: ['Adolf', 'Alice'],
      24: ['Johannes Döparens dag (ingen namnsdag)'],
      25: ['David', 'Salomon'],
      26: ['Lea', 'Rakel'],
      27: ['Fingal', 'Selma'],
      28: ['Leo'],
      29: ['Peter', 'Petra'],
      30: ['Elof', 'Leif']
    },
    7: {
      1: ['Aron', 'Mirjam'],
      2: ['Rosa', 'Rosita'],
      3: ['Aurora'],
      4: ['Ulla', 'Ulrika'],
      5: ['Laila', 'Ritva'],
      6: ['Esaias', 'Jessika'],
      7: ['Klas'],
      8: ['Kjell'],
      9: ['Jörgen', 'Örjan'],
      10: ['Andrea', 'André'],
      11: ['Eleonora', 'Ellinor'],
      12: ['Herman', 'Hermine'],
      13: ['Joel', 'Judit'],
      14: ['Folke'],
      15: ['Ragnhild', 'Ragnvald'],
      16: ['Reine', 'Reinhold'],
      17: ['Bruno'],
      18: ['Fredrik', 'Fritz'],
      19: ['Sara'],
      20: ['Greta', 'Margareta'],
      21: ['Johanna'],
      22: ['Madeleine', 'Magdalena'],
      23: ['Emma', 'Emmy'],
      24: ['Kerstin', 'Kristina'],
      25: ['Jakob'],
      26: ['Jasmine', 'Jesper'],
      27: ['Marta'],
      28: ['Botvid', 'Seved'],
      29: ['Olle', 'Olof'],
      30: ['Algot'],
      31: ['Elin', 'Helena']
    },
    8: {
      1: ['Per'],
      2: ['Kajsa', 'Karin'],
      3: ['Tage'],
      4: ['Arne', 'Arnold'],
      5: ['Alrik', 'Ulrik'],
      6: ['Alfons', 'Inez'],
      7: ['Denise', 'Dennis'],
      8: ['Silvia', 'Sylvia'],
      9: ['Roland'],
      10: ['Lars'],
      11: ['Susanna'],
      12: ['Klara'],
      13: ['Kaj'],
      14: ['Uno'],
      15: ['Estelle', 'Stella'],
      16: ['Brynolf'],
      17: ['Valter', 'Verner'],
      18: ['Ellen', 'Lena'],
      19: ['Magnus', 'Måns'],
      20: ['Bernhard', 'Bernt'],
      21: ['Jon', 'Jonna'],
      22: ['Henrietta', 'Henrika'],
      23: ['Signe', 'Signhild'],
      24: ['Bartolomeus'],
      25: ['Louise', 'Lovisa'],
      26: ['Östen'],
      27: ['Raoul', 'Rolf'],
      28: ['Fatima', 'Leila'],
      29: ['Hampus', 'Hans'],
      30: ['Albert', 'Albertina'],
      31: ['Arvid', 'Vidar']
    },
    9: {
      1: ['Sam', 'Samuel'],
      2: ['Justina', 'Justus'],
      3: ['Alfhild', 'Alva'],
      4: ['Gisela'],
      5: ['Adela', 'Heidi'],
      6: ['Lilian', 'Lilly'],
      7: ['Kevin', 'Roy'],
      8: ['Alma', 'Hulda'],
      9: ['Anita', 'Annette'],
      10: ['Tord', 'Turid'],
      11: ['Dagny', 'Helny'],
      12: ['Åsa', 'Åslög'],
      13: ['Sture'],
      14: ['Ida', 'Ronja'],
      15: ['Sigrid', 'Siri'],
      16: ['Dag', 'Daga'],
      17: ['Hildegard', 'Magnhild'],
      18: ['Orvar'],
      19: ['Fredrika'],
      20: ['Elise', 'Lisa'],
      21: ['Matteus'],
      22: ['Maurits', 'Moritz'],
      23: ['Tea', 'Tekla'],
      24: ['Gerhard', 'Gert'],
      25: ['Tryggve'],
      26: ['Einar', 'Enar'],
      27: ['Dagmar', 'Rigmor'],
      28: ['Lennart', 'Leonard'],
      29: ['Mikael', 'Mikaela'],
      30: ['Helge']
    },
    10: {
      1: ['Ragna', 'Ragnar'],
      2: ['Love', 'Ludvig'],
      3: ['Evald', 'Osvald'],
      4: ['Frank', 'Frans'],
      5: ['Bror'],
      6: ['Jennifer', 'Jenny'],
      7: ['Birgitta', 'Britta'],
      8: ['Nils'],
      9: ['Inger', 'Ingrid'],
      10: ['Harriet', 'Harry'],
      11: ['Erling', 'Jarl'],
      12: ['Manfred', 'Valfrid'],
      13: ['Berit', 'Birgit'],
      14: ['Stellan'],
      15: ['Hedvig', 'Hillevi'],
      16: ['Finn'],
      17: ['Antonia', 'Toini'],
      18: ['Lukas'],
      19: ['Tor', 'Tore'],
      20: ['Sibylla'],
      21: ['Ursula', 'Yrsa'],
      22: ['Marika', 'Marita'],
      23: ['Severin', 'Sören'],
      24: ['Eilert', 'Evert'],
      25: ['Inga', 'Ingalill'],
      26: ['Amanda', 'Rasmus'],
      27: ['Sabina'],
      28: ['Simon', 'Simone'],
      29: ['Viola'],
      30: ['Elsa', 'Isabella'],
      31: ['Edgar', 'Edit']
    },
    11: {
      1: ['Allhelgonadagen (ingen namnsdag)'],
      2: ['Tim', 'Tobias'],
      3: ['Hubert', 'Hugo'],
      4: ['Sverker'],
      5: ['Eugen', 'Eugenia'],
      6: ['Gustav Adolf'],
      7: ['Ingegerd', 'Ingela'],
      8: ['Vendela'],
      9: ['Teodor', 'Teodora'],
      10: ['Martin', 'Martina'],
      11: ['Mårten'],
      12: ['Konrad', 'Kurt'],
      13: ['Krister', 'Kristian'],
      14: ['Emil', 'Emilia'],
      15: ['Leopold'],
      16: ['Vibeke', 'Viveka'],
      17: ['Naemi', 'Naima'],
      18: ['Lillemor', 'Moa'],
      19: ['Elisabet', 'Lisbet'],
      20: ['Marina', 'Pontus'],
      21: ['Helga', 'Olga'],
      22: ['Cecilia', 'Sissela'],
      23: ['Klemens'],
      24: ['Gudrun', 'Rune'],
      25: ['Katarina', 'Katja'],
      26: ['Linus'],
      27: ['Asta', 'Astrid'],
      28: ['Malte'],
      29: ['Sune'],
      30: ['Anders', 'Andreas']
    },
    12: {
      1: ['Oskar', 'Ossian'],
      2: ['Beata', 'Beatrice'],
      3: ['Cornelia', 'Lydia'],
      4: ['Barbara', 'Barbro'],
      5: ['Sven'],
      6: ['Niklas', 'Nikolaus'],
      7: ['Angela', 'Angelika'],
      8: ['Virginia'],
      9: ['Anna'],
      10: ['Malena', 'Malin'],
      11: ['Daniel', 'Daniela'],
      12: ['Alexander', 'Alexis'],
      13: ['Lucia'],
      14: ['Sixten', 'Sten'],
      15: ['Gottfrid'],
      16: ['Assar'],
      17: ['Stig'],
      18: ['Abraham'],
      19: ['Isak'],
      20: ['Israel', 'Moses'],
      21: ['Tomas'],
      22: ['Jonatan', 'Natanael'],
      23: ['Adam'],
      24: ['Eva'],
      25: ['Juldagen (ingen namnsdag)'],
      26: ['Staffan', 'Stefan'],
      27: ['Johan', 'Johannes'],
      28: ['Benjamin'],
      29: ['Natalia', 'Natalie'],
      30: ['Abel', 'Set'],
      31: ['Sylvester']
    }
  },
  namesByFirstLetter: {
    N: [{
      name: 'Nadja',
      date: '8/4'
    }, {
      name: 'Naemi',
      date: '17/11'
    }, {
      name: 'Naima',
      date: '17/11'
    }, {
      name: 'Nanna',
      date: '3/4'
    }, {
      name: 'Natalia',
      date: '29/12'
    }, {
      name: 'Natalie',
      date: '29/12'
    }, {
      name: 'Natanael',
      date: '22/12'
    }, {
      name: 'Niklas',
      date: '6/12'
    }, {
      name: 'Nikolaus',
      date: '6/12'
    }, {
      name: 'Nils',
      date: '8/10'
    }, {
      name: 'Noa',
      date: '31/3'
    }],
    S: [{
      name: 'Sabina',
      date: '27/10'
    }, {
      name: 'Saga',
      date: '8/3'
    }, {
      name: 'Salomon',
      date: '25/6'
    }, {
      name: 'Sam',
      date: '1/9'
    }, {
      name: 'Samuel',
      date: '1/9'
    }, {
      name: 'Sandra',
      date: '17/2'
    }, {
      name: 'Sara',
      date: '19/7'
    }, {
      name: 'Sebastian',
      date: '20/1'
    }, {
      name: 'Selma',
      date: '27/6'
    }, {
      name: 'Set',
      date: '30/12'
    }, {
      name: 'Seved',
      date: '28/7'
    }, {
      name: 'Severin',
      date: '23/10'
    }, {
      name: 'Sibylla',
      date: '20/10'
    }, {
      name: 'Sigbritt',
      date: '10/1'
    }, {
      name: 'Sigfrid',
      date: '15/2'
    }, {
      name: 'Signe',
      date: '23/8'
    }, {
      name: 'Signhild',
      date: '23/8'
    }, {
      name: 'Sigrid',
      date: '15/9'
    }, {
      name: 'Sigurd',
      date: '10/1'
    }, {
      name: 'Sigvard',
      date: '25/2'
    }, {
      name: 'Silvia',
      date: '8/8'
    }, {
      name: 'Simon',
      date: '28/10'
    }, {
      name: 'Simone',
      date: '28/10'
    }, {
      name: 'Siri',
      date: '15/9'
    }, {
      name: 'Sissela',
      date: '22/11'
    }, {
      name: 'Siv',
      date: '8/3'
    }, {
      name: 'Sivert',
      date: '25/2'
    }, {
      name: 'Sixten',
      date: '14/12'
    }, {
      name: 'Sofia',
      date: '15/5'
    }, {
      name: 'Solbritt',
      date: '4/6'
    }, {
      name: 'Solveig',
      date: '4/6'
    }, {
      name: 'Sonja',
      date: '15/5'
    }, {
      name: 'Staffan',
      date: '26/12'
    }, {
      name: 'Stefan',
      date: '26/12'
    }, {
      name: 'Stella',
      date: '15/8'
    }, {
      name: 'Stellan',
      date: '14/10'
    }, {
      name: 'Sten',
      date: '14/12'
    }, {
      name: 'Stig',
      date: '17/12'
    }, {
      name: 'Sture',
      date: '13/9'
    }, {
      name: 'Styrbjörn',
      date: '10/5'
    }, {
      name: 'Sune',
      date: '29/11'
    }, {
      name: 'Susanna',
      date: '11/8'
    }, {
      name: 'Svante',
      date: '10/6'
    }, {
      name: 'Svea',
      date: '2/1'
    }, {
      name: 'Sven',
      date: '5/12'
    }, {
      name: 'Sverker',
      date: '4/11'
    }, {
      name: 'Sylvester',
      date: '31/12'
    }, {
      name: 'Sylvia',
      date: '8/8'
    }, {
      name: 'Sören',
      date: '23/10'
    }],
    A: [{
      name: 'Abel',
      date: '30/12'
    }, {
      name: 'Abraham',
      date: '18/12'
    }, {
      name: 'Ada',
      date: '10/3'
    }, {
      name: 'Adam',
      date: '23/12'
    }, {
      name: 'Adela',
      date: '5/9'
    }, {
      name: 'Adolf',
      date: '23/6'
    }, {
      name: 'Adrian',
      date: '4/3'
    }, {
      name: 'Adriana',
      date: '4/3'
    }, {
      name: 'Agata',
      date: '5/2'
    }, {
      name: 'Agda',
      date: '5/2'
    }, {
      name: 'Agne',
      date: '13/2'
    }, {
      name: 'Agnes',
      date: '21/1'
    }, {
      name: 'Agneta',
      date: '21/1'
    }, {
      name: 'Aina',
      date: '13/6'
    }, {
      name: 'Aino',
      date: '13/6'
    }, {
      name: 'Albert',
      date: '30/8'
    }, {
      name: 'Albertina',
      date: '30/8'
    }, {
      name: 'Albin',
      date: '1/3'
    }, {
      name: 'Alexander',
      date: '12/12'
    }, {
      name: 'Alexandra',
      date: '17/2'
    }, {
      name: 'Alexis',
      date: '12/12'
    }, {
      name: 'Alf',
      date: '21/6'
    }, {
      name: 'Alfhild',
      date: '3/9'
    }, {
      name: 'Alfons',
      date: '6/8'
    }, {
      name: 'Alfred',
      date: '3/1'
    }, {
      name: 'Alfrida',
      date: '3/1'
    }, {
      name: 'Algot',
      date: '30/7'
    }, {
      name: 'Alice',
      date: '23/6'
    }, {
      name: 'Allan',
      date: '22/4'
    }, {
      name: 'Alma',
      date: '8/9'
    }, {
      name: 'Alrik',
      date: '5/8'
    }, {
      name: 'Alva',
      date: '3/9'
    }, {
      name: 'Alvar',
      date: '21/6'
    }, {
      name: 'Amalia',
      date: '20/4'
    }, {
      name: 'Amanda',
      date: '26/10'
    }, {
      name: 'Amelie',
      date: '20/4'
    }, {
      name: 'Anders',
      date: '30/11'
    }, {
      name: 'Andrea',
      date: '10/7'
    }, {
      name: 'Andreas',
      date: '30/11'
    }, {
      name: 'André',
      date: '10/7'
    }, {
      name: 'Angela',
      date: '7/12'
    }, {
      name: 'Angelika',
      date: '7/12'
    }, {
      name: 'Anita',
      date: '9/9'
    }, {
      name: 'Anna',
      date: '9/12'
    }, {
      name: 'Anneli',
      date: '21/4'
    }, {
      name: 'Annette',
      date: '9/9'
    }, {
      name: 'Annika',
      date: '21/4'
    }, {
      name: 'Anselm',
      date: '4/2'
    }, {
      name: 'Ansgar',
      date: '4/2'
    }, {
      name: 'Anton',
      date: '17/1'
    }, {
      name: 'Antonia',
      date: '17/10'
    }, {
      name: 'Arne',
      date: '4/8'
    }, {
      name: 'Arnold',
      date: '4/8'
    }, {
      name: 'Aron',
      date: '1/7'
    }, {
      name: 'Artur',
      date: '13/4'
    }, {
      name: 'Arvid',
      date: '31/8'
    }, {
      name: 'Assar',
      date: '16/12'
    }, {
      name: 'Asta',
      date: '27/11'
    }, {
      name: 'Astrid',
      date: '27/11'
    }, {
      name: 'August',
      date: '7/1'
    }, {
      name: 'Augusta',
      date: '7/1'
    }, {
      name: 'Aurora',
      date: '3/7'
    }, {
      name: 'Axel',
      date: '16/6'
    }, {
      name: 'Axelina',
      date: '16/6'
    }],
    R: [{
      name: 'Rafael',
      date: '24/3'
    }, {
      name: 'Ragna',
      date: '1/10'
    }, {
      name: 'Ragnar',
      date: '1/10'
    }, {
      name: 'Ragnhild',
      date: '15/7'
    }, {
      name: 'Ragnvald',
      date: '15/7'
    }, {
      name: 'Rakel',
      date: '26/6'
    }, {
      name: 'Ralf',
      date: '27/3'
    }, {
      name: 'Raoul',
      date: '27/8'
    }, {
      name: 'Rasmus',
      date: '26/10'
    }, {
      name: 'Rebecka',
      date: '17/5'
    }, {
      name: 'Regina',
      date: '12/3'
    }, {
      name: 'Reidar',
      date: '9/5'
    }, {
      name: 'Reidun',
      date: '9/5'
    }, {
      name: 'Reine',
      date: '16/7'
    }, {
      name: 'Reinhold',
      date: '16/7'
    }, {
      name: 'Rigmor',
      date: '27/9'
    }, {
      name: 'Rikard',
      date: '7/2'
    }, {
      name: 'Rita',
      date: '6/5'
    }, {
      name: 'Ritva',
      date: '5/7'
    }, {
      name: 'Robert',
      date: '7/6'
    }, {
      name: 'Robin',
      date: '7/6'
    }, {
      name: 'Roger',
      date: '2/6'
    }, {
      name: 'Roland',
      date: '9/8'
    }, {
      name: 'Rolf',
      date: '27/8'
    }, {
      name: 'Ronald',
      date: '16/5'
    }, {
      name: 'Ronja',
      date: '14/9'
    }, {
      name: 'Ronny',
      date: '16/5'
    }, {
      name: 'Rosa',
      date: '2/7'
    }, {
      name: 'Rosita',
      date: '2/7'
    }, {
      name: 'Roy',
      date: '7/9'
    }, {
      name: 'Ruben',
      date: '17/5'
    }, {
      name: 'Rudolf',
      date: '27/3'
    }, {
      name: 'Rune',
      date: '24/11'
    }, {
      name: 'Rut',
      date: '4/1'
    }, {
      name: 'Rutger',
      date: '2/6'
    }],
    H: [{
      name: 'Hakon',
      date: '14/6'
    }, {
      name: 'Halvar',
      date: '14/5'
    }, {
      name: 'Halvard',
      date: '14/5'
    }, {
      name: 'Hampus',
      date: '29/8'
    }, {
      name: 'Hanna',
      date: '5/1'
    }, {
      name: 'Hannele',
      date: '5/1'
    }, {
      name: 'Hans',
      date: '29/8'
    }, {
      name: 'Harald',
      date: '1/4'
    }, {
      name: 'Harriet',
      date: '10/10'
    }, {
      name: 'Harry',
      date: '10/10'
    }, {
      name: 'Hedvig',
      date: '15/10'
    }, {
      name: 'Heidi',
      date: '5/9'
    }, {
      name: 'Helena',
      date: '31/7'
    }, {
      name: 'Helga',
      date: '21/11'
    }, {
      name: 'Helge',
      date: '30/9'
    }, {
      name: 'Helmer',
      date: '16/1'
    }, {
      name: 'Helny',
      date: '11/9'
    }, {
      name: 'Hemming',
      date: '22/5'
    }, {
      name: 'Henning',
      date: '22/5'
    }, {
      name: 'Henrietta',
      date: '22/8'
    }, {
      name: 'Henrik',
      date: '19/1'
    }, {
      name: 'Henrika',
      date: '22/8'
    }, {
      name: 'Henry',
      date: '19/1'
    }, {
      name: 'Herbert',
      date: '16/3'
    }, {
      name: 'Herman',
      date: '12/7'
    }, {
      name: 'Hermine',
      date: '12/7'
    }, {
      name: 'Hervor',
      date: '1/4'
    }, {
      name: 'Hilda',
      date: '18/1'
    }, {
      name: 'Hildegard',
      date: '17/9'
    }, {
      name: 'Hilding',
      date: '21/2'
    }, {
      name: 'Hildur',
      date: '18/1'
    }, {
      name: 'Hillevi',
      date: '15/10'
    }, {
      name: 'Hjalmar',
      date: '16/1'
    }, {
      name: 'Hjördis',
      date: '3/2'
    }, {
      name: 'Holger',
      date: '30/3'
    }, {
      name: 'Holmfrid',
      date: '30/3'
    }, {
      name: 'Hubert',
      date: '3/11'
    }, {
      name: 'Hugo',
      date: '3/11'
    }, {
      name: 'Hulda',
      date: '8/9'
    }, {
      name: 'Håkan',
      date: '14/6'
    }],
    B: [{
      name: 'Baltsar',
      date: '6/1'
    }, {
      name: 'Barbara',
      date: '4/12'
    }, {
      name: 'Barbro',
      date: '4/12'
    }, {
      name: 'Bartolomeus',
      date: '24/8'
    }, {
      name: 'Beata',
      date: '2/12'
    }, {
      name: 'Beatrice',
      date: '2/12'
    }, {
      name: 'Beda',
      date: '27/5'
    }, {
      name: 'Bengt',
      date: '21/3'
    }, {
      name: 'Benjamin',
      date: '28/12'
    }, {
      name: 'Berit',
      date: '13/10'
    }, {
      name: 'Bernhard',
      date: '20/8'
    }, {
      name: 'Bernt',
      date: '20/8'
    }, {
      name: 'Bert',
      date: '8/2'
    }, {
      name: 'Berta',
      date: '8/2'
    }, {
      name: 'Berthold',
      date: '11/6'
    }, {
      name: 'Bertil',
      date: '11/6'
    }, {
      name: 'Birger',
      date: '9/6'
    }, {
      name: 'Birgit',
      date: '13/10'
    }, {
      name: 'Birgitta',
      date: '7/10'
    }, {
      name: 'Bjarne',
      date: '18/6'
    }, {
      name: 'Björn',
      date: '18/6'
    }, {
      name: 'Blenda',
      date: '27/5'
    }, {
      name: 'Bo',
      date: '5/6'
    }, {
      name: 'Bodil',
      date: '26/1'
    }, {
      name: 'Boel',
      date: '26/1'
    }, {
      name: 'Borghild',
      date: '28/5'
    }, {
      name: 'Boris',
      date: '10/6'
    }, {
      name: 'Botvid',
      date: '28/7'
    }, {
      name: 'Britta',
      date: '7/10'
    }, {
      name: 'Bror',
      date: '5/10'
    }, {
      name: 'Bruno',
      date: '17/7'
    }, {
      name: 'Brynolf',
      date: '16/8'
    }, {
      name: 'Börje',
      date: '9/6'
    }],
    K: [{
      name: 'Kaj',
      date: '13/8'
    }, {
      name: 'Kajsa',
      date: '2/8'
    }, {
      name: 'Karin',
      date: '2/8'
    }, {
      name: 'Karl',
      date: '28/1'
    }, {
      name: 'Karla',
      date: '28/1'
    }, {
      name: 'Karolina',
      date: '20/5'
    }, {
      name: 'Kasper',
      date: '6/1'
    }, {
      name: 'Katarina',
      date: '25/11'
    }, {
      name: 'Katja',
      date: '25/11'
    }, {
      name: 'Kennet',
      date: '22/3'
    }, {
      name: 'Kent',
      date: '22/3'
    }, {
      name: 'Kerstin',
      date: '24/7'
    }, {
      name: 'Kevin',
      date: '7/9'
    }, {
      name: 'Kim',
      date: '20/3'
    }, {
      name: 'Kjell',
      date: '8/7'
    }, {
      name: 'Klara',
      date: '12/8'
    }, {
      name: 'Klas',
      date: '7/7'
    }, {
      name: 'Klemens',
      date: '23/11'
    }, {
      name: 'Knut',
      date: '13/1'
    }, {
      name: 'Konrad',
      date: '12/11'
    }, {
      name: 'Konstantin',
      date: '21/5'
    }, {
      name: 'Krister',
      date: '13/11'
    }, {
      name: 'Kristian',
      date: '13/11'
    }, {
      name: 'Kristina',
      date: '24/7'
    }, {
      name: 'Kristoffer',
      date: '15/3'
    }, {
      name: 'Kurt',
      date: '12/11'
    }],
    M: [{
      name: 'Madeleine',
      date: '22/7'
    }, {
      name: 'Magdalena',
      date: '22/7'
    }, {
      name: 'Magnhild',
      date: '17/9'
    }, {
      name: 'Magnus',
      date: '19/8'
    }, {
      name: 'Maj',
      date: '19/5'
    }, {
      name: 'Maja',
      date: '28/2'
    }, {
      name: 'Majken',
      date: '19/5'
    }, {
      name: 'Majvor',
      date: '8/6'
    }, {
      name: 'Malena',
      date: '10/12'
    }, {
      name: 'Malin',
      date: '10/12'
    }, {
      name: 'Malkolm',
      date: '28/3'
    }, {
      name: 'Malte',
      date: '28/11'
    }, {
      name: 'Manfred',
      date: '12/10'
    }, {
      name: 'Margareta',
      date: '20/7'
    }, {
      name: 'Margit',
      date: '15/6'
    }, {
      name: 'Margot',
      date: '15/6'
    }, {
      name: 'Maria',
      date: '28/2'
    }, {
      name: 'Mariana',
      date: '30/4'
    }, {
      name: 'Marianne',
      date: '4/4'
    }, {
      name: 'Marika',
      date: '22/10'
    }, {
      name: 'Marina',
      date: '20/11'
    }, {
      name: 'Marit',
      date: '6/5'
    }, {
      name: 'Marita',
      date: '22/10'
    }, {
      name: 'Markus',
      date: '25/4'
    }, {
      name: 'Marlene',
      date: '4/4'
    }, {
      name: 'Marta',
      date: '27/7'
    }, {
      name: 'Martin',
      date: '10/11'
    }, {
      name: 'Martina',
      date: '10/11'
    }, {
      name: 'Matilda',
      date: '14/3'
    }, {
      name: 'Mats',
      date: '24/2'
    }, {
      name: 'Matteus',
      date: '21/9'
    }, {
      name: 'Mattias',
      date: '24/2'
    }, {
      name: 'Maud',
      date: '14/3'
    }, {
      name: 'Maurits',
      date: '22/9'
    }, {
      name: 'Max',
      date: '1/2'
    }, {
      name: 'Maximilian',
      date: '1/2'
    }, {
      name: 'Melker',
      date: '6/1'
    }, {
      name: 'Mikael',
      date: '29/9'
    }, {
      name: 'Mikaela',
      date: '29/9'
    }, {
      name: 'Mirjam',
      date: '1/7'
    }, {
      name: 'Moa',
      date: '18/11'
    }, {
      name: 'Mona',
      date: '4/5'
    }, {
      name: 'Monika',
      date: '4/5'
    }, {
      name: 'Morgan',
      date: '28/3'
    }, {
      name: 'Moritz',
      date: '22/9'
    }, {
      name: 'Moses',
      date: '20/12'
    }, {
      name: 'Märit',
      date: '11/5'
    }, {
      name: 'Märta',
      date: '11/5'
    }, {
      name: 'Måns',
      date: '19/8'
    }, {
      name: 'Mårten',
      date: '11/11'
    }],
    E: [{
      name: 'Ebba',
      date: '6/3'
    }, {
      name: 'Ebbe',
      date: '6/3'
    }, {
      name: 'Edgar',
      date: '31/10'
    }, {
      name: 'Edit',
      date: '31/10'
    }, {
      name: 'Edla',
      date: '10/3'
    }, {
      name: 'Edmund',
      date: '18/3'
    }, {
      name: 'Edvard',
      date: '18/3'
    }, {
      name: 'Edvin',
      date: '11/3'
    }, {
      name: 'Egon',
      date: '11/3'
    }, {
      name: 'Eilert',
      date: '24/10'
    }, {
      name: 'Einar',
      date: '26/9'
    }, {
      name: 'Eivor',
      date: '8/6'
    }, {
      name: 'Eleonora',
      date: '11/7'
    }, {
      name: 'Elias',
      date: '17/4'
    }, {
      name: 'Elin',
      date: '31/7'
    }, {
      name: 'Elis',
      date: '17/4'
    }, {
      name: 'Elisabet',
      date: '19/11'
    }, {
      name: 'Elise',
      date: '20/9'
    }, {
      name: 'Ella',
      date: '19/2'
    }, {
      name: 'Ellen',
      date: '18/8'
    }, {
      name: 'Ellinor',
      date: '11/7'
    }, {
      name: 'Elof',
      date: '30/6'
    }, {
      name: 'Elsa',
      date: '30/10'
    }, {
      name: 'Elvira',
      date: '1/3'
    }, {
      name: 'Emanuel',
      date: '26/3'
    }, {
      name: 'Emil',
      date: '14/11'
    }, {
      name: 'Emilia',
      date: '14/11'
    }, {
      name: 'Emma',
      date: '23/7'
    }, {
      name: 'Emmy',
      date: '23/7'
    }, {
      name: 'Enar',
      date: '26/9'
    }, {
      name: 'Engelbrekt',
      date: '27/4'
    }, {
      name: 'Erhard',
      date: '5/5'
    }, {
      name: 'Erik',
      date: '18/5'
    }, {
      name: 'Erika',
      date: '24/1'
    }, {
      name: 'Erland',
      date: '8/1'
    }, {
      name: 'Erling',
      date: '11/10'
    }, {
      name: 'Erna',
      date: '2/3'
    }, {
      name: 'Ernst',
      date: '2/3'
    }, {
      name: 'Esaias',
      date: '6/7'
    }, {
      name: 'Esbjörn',
      date: '10/5'
    }, {
      name: 'Eskil',
      date: '12/6'
    }, {
      name: 'Estelle',
      date: '15/8'
    }, {
      name: 'Ester',
      date: '31/3'
    }, {
      name: 'Eugen',
      date: '5/11'
    }, {
      name: 'Eugenia',
      date: '5/11'
    }, {
      name: 'Eva',
      date: '24/12'
    }, {
      name: 'Evald',
      date: '3/10'
    }, {
      name: 'Evelina',
      date: '12/2'
    }, {
      name: 'Evelyn',
      date: '12/2'
    }, {
      name: 'Evert',
      date: '24/10'
    }, {
      name: 'Evy',
      date: '12/2'
    }],
    G: [{
      name: 'Gabriel',
      date: '24/3'
    }, {
      name: 'Gabriella',
      date: '19/2'
    }, {
      name: 'Georg',
      date: '23/4'
    }, {
      name: 'Gerd',
      date: '23/3'
    }, {
      name: 'Gerda',
      date: '23/3'
    }, {
      name: 'Gerhard',
      date: '24/9'
    }, {
      name: 'Germund',
      date: '19/6'
    }, {
      name: 'Gert',
      date: '24/9'
    }, {
      name: 'Gertrud',
      date: '17/3'
    }, {
      name: 'Gilbert',
      date: '16/3'
    }, {
      name: 'Gisela',
      date: '4/9'
    }, {
      name: 'Glenn',
      date: '22/4'
    }, {
      name: 'Gottfrid',
      date: '15/12'
    }, {
      name: 'Gotthard',
      date: '5/5'
    }, {
      name: 'Greger',
      date: '13/3'
    }, {
      name: 'Greta',
      date: '20/7'
    }, {
      name: 'Gudmar',
      date: '3/6'
    }, {
      name: 'Gudmund',
      date: '2/4'
    }, {
      name: 'Gudrun',
      date: '24/11'
    }, {
      name: 'Gun',
      date: '1/6'
    }, {
      name: 'Gunborg',
      date: '3/3'
    }, {
      name: 'Gunder',
      date: '9/1'
    }, {
      name: 'Gunhild',
      date: '30/1'
    }, {
      name: 'Gunilla',
      date: '30/1'
    }, {
      name: 'Gunnar',
      date: '9/1'
    }, {
      name: 'Gunnel',
      date: '1/6'
    }, {
      name: 'Gunvor',
      date: '3/3'
    }, {
      name: 'Gustav',
      date: '6/6'
    }, {
      name: 'Gustav Adolf',
      date: '6/11'
    }, {
      name: 'Göran',
      date: '23/4'
    }, {
      name: 'Görel',
      date: '19/6'
    }, {
      name: 'Gösta',
      date: '6/6'
    }, {
      name: 'Göta',
      date: '27/1'
    }, {
      name: 'Göte',
      date: '27/1'
    }],
    J: [{
      name: 'Jakob',
      date: '25/7'
    }, {
      name: 'Jan',
      date: '11/1'
    }, {
      name: 'Jane',
      date: '3/5'
    }, {
      name: 'Jannike',
      date: '11/1'
    }, {
      name: 'Jarl',
      date: '11/10'
    }, {
      name: 'Jasmine',
      date: '26/7'
    }, {
      name: 'Jeanette',
      date: '29/5'
    }, {
      name: 'Jennifer',
      date: '6/10'
    }, {
      name: 'Jenny',
      date: '6/10'
    }, {
      name: 'Jens',
      date: '29/3'
    }, {
      name: 'Jesper',
      date: '26/7'
    }, {
      name: 'Jessika',
      date: '6/7'
    }, {
      name: 'Joakim',
      date: '20/3'
    }, {
      name: 'Joar',
      date: '31/1'
    }, {
      name: 'Joel',
      date: '13/7'
    }, {
      name: 'Johan',
      date: '27/12'
    }, {
      name: 'Johanna',
      date: '21/7'
    }, {
      name: 'Johannes',
      date: '27/12'
    }, {
      name: 'John',
      date: '3/5'
    }, {
      name: 'Jon',
      date: '21/8'
    }, {
      name: 'Jonas',
      date: '29/3'
    }, {
      name: 'Jonatan',
      date: '22/12'
    }, {
      name: 'Jonna',
      date: '21/8'
    }, {
      name: 'Josef',
      date: '19/3'
    }, {
      name: 'Josefina',
      date: '19/3'
    }, {
      name: 'Judit',
      date: '13/7'
    }, {
      name: 'Julia',
      date: '16/2'
    }, {
      name: 'Julius',
      date: '16/2'
    }, {
      name: 'Justina',
      date: '2/9'
    }, {
      name: 'Justus',
      date: '2/9'
    }, {
      name: 'Jörgen',
      date: '9/7'
    }],
    F: [{
      name: 'Fabian',
      date: '20/1'
    }, {
      name: 'Fanny',
      date: '9/2'
    }, {
      name: 'Fatima',
      date: '28/8'
    }, {
      name: 'Felicia',
      date: '14/1'
    }, {
      name: 'Felix',
      date: '14/1'
    }, {
      name: 'Ferdinand',
      date: '3/4'
    }, {
      name: 'Filip',
      date: '2/5'
    }, {
      name: 'Filippa',
      date: '2/5'
    }, {
      name: 'Fingal',
      date: '27/6'
    }, {
      name: 'Finn',
      date: '16/10'
    }, {
      name: 'Folke',
      date: '14/7'
    }, {
      name: 'Franciska',
      date: '9/2'
    }, {
      name: 'Frank',
      date: '4/10'
    }, {
      name: 'Frans',
      date: '4/10'
    }, {
      name: 'Fredrik',
      date: '18/7'
    }, {
      name: 'Fredrika',
      date: '19/9'
    }, {
      name: 'Frej',
      date: '23/1'
    }, {
      name: 'Freja',
      date: '23/1'
    }, {
      name: 'Frida',
      date: '18/2'
    }, {
      name: 'Frideborg',
      date: '12/1'
    }, {
      name: 'Fridolf',
      date: '12/1'
    }, {
      name: 'Fritiof',
      date: '18/2'
    }, {
      name: 'Fritz',
      date: '18/7'
    }],
    L: [{
      name: 'Lage',
      date: '27/2'
    }, {
      name: 'Laila',
      date: '5/7'
    }, {
      name: 'Lars',
      date: '10/8'
    }, {
      name: 'Laura',
      date: '15/1'
    }, {
      name: 'Lea',
      date: '26/6'
    }, {
      name: 'Leif',
      date: '30/6'
    }, {
      name: 'Leila',
      date: '28/8'
    }, {
      name: 'Lena',
      date: '18/8'
    }, {
      name: 'Lennart',
      date: '28/9'
    }, {
      name: 'Leo',
      date: '28/6'
    }, {
      name: 'Leonard',
      date: '28/9'
    }, {
      name: 'Leopold',
      date: '15/11'
    }, {
      name: 'Lilian',
      date: '6/9'
    }, {
      name: 'Lillemor',
      date: '18/11'
    }, {
      name: 'Lilly',
      date: '6/9'
    }, {
      name: 'Linda',
      date: '20/6'
    }, {
      name: 'Linn',
      date: '13/5'
    }, {
      name: 'Linnea',
      date: '13/5'
    }, {
      name: 'Linus',
      date: '26/11'
    }, {
      name: 'Lisa',
      date: '20/9'
    }, {
      name: 'Lisbet',
      date: '19/11'
    }, {
      name: 'Liv',
      date: '12/4'
    }, {
      name: 'Lorentz',
      date: '15/1'
    }, {
      name: 'Lotta',
      date: '12/5'
    }, {
      name: 'Louise',
      date: '25/8'
    }, {
      name: 'Love',
      date: '2/10'
    }, {
      name: 'Lovisa',
      date: '25/8'
    }, {
      name: 'Lucia',
      date: '13/12'
    }, {
      name: 'Ludvig',
      date: '2/10'
    }, {
      name: 'Lukas',
      date: '18/10'
    }, {
      name: 'Lydia',
      date: '3/12'
    }],
    T: [{
      name: 'Tage',
      date: '3/8'
    }, {
      name: 'Tanja',
      date: '8/4'
    }, {
      name: 'Tea',
      date: '23/9'
    }, {
      name: 'Tekla',
      date: '23/9'
    }, {
      name: 'Teodor',
      date: '9/11'
    }, {
      name: 'Teodora',
      date: '9/11'
    }, {
      name: 'Terese',
      date: '26/4'
    }, {
      name: 'Teresia',
      date: '26/4'
    }, {
      name: 'Tiburtius',
      date: '14/4'
    }, {
      name: 'Tim',
      date: '2/11'
    }, {
      name: 'Tobias',
      date: '2/11'
    }, {
      name: 'Toini',
      date: '17/10'
    }, {
      name: 'Tomas',
      date: '21/12'
    }, {
      name: 'Tony',
      date: '17/1'
    }, {
      name: 'Tor',
      date: '19/10'
    }, {
      name: 'Tora',
      date: '5/3'
    }, {
      name: 'Torbjörn',
      date: '9/3'
    }, {
      name: 'Torborg',
      date: '17/6'
    }, {
      name: 'Tord',
      date: '10/9'
    }, {
      name: 'Tore',
      date: '19/10'
    }, {
      name: 'Torgny',
      date: '26/2'
    }, {
      name: 'Torkel',
      date: '26/2'
    }, {
      name: 'Torleif',
      date: '9/3'
    }, {
      name: 'Torsten',
      date: '23/2'
    }, {
      name: 'Torun',
      date: '23/2'
    }, {
      name: 'Torvald',
      date: '17/6'
    }, {
      name: 'Tove',
      date: '5/3'
    }, {
      name: 'Tryggve',
      date: '25/9'
    }, {
      name: 'Ture',
      date: '28/4'
    }, {
      name: 'Turid',
      date: '10/9'
    }, {
      name: 'Tyko',
      date: '29/4'
    }, {
      name: 'Tyra',
      date: '28/4'
    }],
    V: [{
      name: 'Valborg',
      date: '1/5'
    }, {
      name: 'Valdemar',
      date: '18/4'
    }, {
      name: 'Valentin',
      date: '14/2'
    }, {
      name: 'Valfrid',
      date: '12/10'
    }, {
      name: 'Valter',
      date: '17/8'
    }, {
      name: 'Vanja',
      date: '24/5'
    }, {
      name: 'Vega',
      date: '24/4'
    }, {
      name: 'Vendela',
      date: '8/11'
    }, {
      name: 'Vera',
      date: '30/5'
    }, {
      name: 'Verner',
      date: '17/8'
    }, {
      name: 'Veronika',
      date: '30/5'
    }, {
      name: 'Vibeke',
      date: '16/11'
    }, {
      name: 'Vidar',
      date: '31/8'
    }, {
      name: 'Viktor',
      date: '22/1'
    }, {
      name: 'Viktoria',
      date: '12/3'
    }, {
      name: 'Vilhelm',
      date: '6/4'
    }, {
      name: 'Vilhelmina',
      date: '26/5'
    }, {
      name: 'Vilma',
      date: '26/5'
    }, {
      name: 'Vincent',
      date: '22/1'
    }, {
      name: 'Viola',
      date: '29/10'
    }, {
      name: 'Virginia',
      date: '8/12'
    }, {
      name: 'Viveka',
      date: '16/11'
    }, {
      name: 'Vivianne',
      date: '20/2'
    }, {
      name: 'Volmar',
      date: '18/4'
    }],
    P: [{
      name: 'Patricia',
      date: '16/4'
    }, {
      name: 'Patrik',
      date: '16/4'
    }, {
      name: 'Paul',
      date: '25/1'
    }, {
      name: 'Paula',
      date: '22/6'
    }, {
      name: 'Paulina',
      date: '22/6'
    }, {
      name: 'Per',
      date: '1/8'
    }, {
      name: 'Pernilla',
      date: '31/5'
    }, {
      name: 'Peter',
      date: '29/6'
    }, {
      name: 'Petra',
      date: '29/6'
    }, {
      name: 'Petronella',
      date: '31/5'
    }, {
      name: 'Pia',
      date: '22/2'
    }, {
      name: 'Pontus',
      date: '20/11'
    }, {
      name: 'Pål',
      date: '25/1'
    }],
    D: [{
      name: 'Dag',
      date: '16/9'
    }, {
      name: 'Daga',
      date: '16/9'
    }, {
      name: 'Dagmar',
      date: '27/9'
    }, {
      name: 'Dagny',
      date: '11/9'
    }, {
      name: 'Daniel',
      date: '11/12'
    }, {
      name: 'Daniela',
      date: '11/12'
    }, {
      name: 'David',
      date: '25/6'
    }, {
      name: 'Denise',
      date: '7/8'
    }, {
      name: 'Dennis',
      date: '7/8'
    }, {
      name: 'Desideria',
      date: '23/5'
    }, {
      name: 'Desirée',
      date: '23/5'
    }, {
      name: 'Diana',
      date: '29/1'
    }, {
      name: 'Dick',
      date: '7/2'
    }, {
      name: 'Disa',
      date: '3/2'
    }, {
      name: 'Doris',
      date: '6/2'
    }, {
      name: 'Dorotea',
      date: '6/2'
    }, {
      name: 'Douglas',
      date: '13/4'
    }],
    I: [{
      name: 'Ida',
      date: '14/9'
    }, {
      name: 'Inez',
      date: '6/8'
    }, {
      name: 'Inga',
      date: '25/10'
    }, {
      name: 'Ingalill',
      date: '25/10'
    }, {
      name: 'Inge',
      date: '11/2'
    }, {
      name: 'Ingeborg',
      date: '28/5'
    }, {
      name: 'Ingegerd',
      date: '7/11'
    }, {
      name: 'Ingela',
      date: '7/11'
    }, {
      name: 'Ingemar',
      date: '3/6'
    }, {
      name: 'Ingemund',
      date: '2/4'
    }, {
      name: 'Inger',
      date: '9/10'
    }, {
      name: 'Ingrid',
      date: '9/10'
    }, {
      name: 'Ingvar',
      date: '10/4'
    }, {
      name: 'Ingvor',
      date: '10/4'
    }, {
      name: 'Irene',
      date: '5/4'
    }, {
      name: 'Iris',
      date: '10/2'
    }, {
      name: 'Irja',
      date: '5/4'
    }, {
      name: 'Irma',
      date: '7/4'
    }, {
      name: 'Irmelin',
      date: '7/4'
    }, {
      name: 'Isabella',
      date: '30/10'
    }, {
      name: 'Isak',
      date: '19/12'
    }, {
      name: 'Israel',
      date: '20/12'
    }, {
      name: 'Ivan',
      date: '24/5'
    }, {
      name: 'Ivar',
      date: '31/1'
    }],
    Y: [{
      name: 'Ylva',
      date: '11/4'
    }, {
      name: 'Yngve',
      date: '11/2'
    }, {
      name: 'Yrsa',
      date: '21/10'
    }, {
      name: 'Yvonne',
      date: '29/5'
    }],
    O: [{
      name: 'Ola',
      date: '19/4'
    }, {
      name: 'Olaus',
      date: '19/4'
    }, {
      name: 'Olga',
      date: '21/11'
    }, {
      name: 'Oliver',
      date: '15/4'
    }, {
      name: 'Olivia',
      date: '15/4'
    }, {
      name: 'Olle',
      date: '29/7'
    }, {
      name: 'Olof',
      date: '29/7'
    }, {
      name: 'Orvar',
      date: '18/9'
    }, {
      name: 'Oskar',
      date: '1/12'
    }, {
      name: 'Ossian',
      date: '1/12'
    }, {
      name: 'Osvald',
      date: '3/10'
    }, {
      name: 'Ottilia',
      date: '9/4'
    }, {
      name: 'Otto',
      date: '9/4'
    }, {
      name: 'Ove',
      date: '13/2'
    }],
    C: [{
      name: 'Camilla',
      date: '7/3'
    }, {
      name: 'Carina',
      date: '7/5'
    }, {
      name: 'Carita',
      date: '7/5'
    }, {
      name: 'Carola',
      date: '20/5'
    }, {
      name: 'Cecilia',
      date: '22/11'
    }, {
      name: 'Charlotta',
      date: '12/5'
    }, {
      name: 'Christel',
      date: '15/3'
    }, {
      name: 'Conny',
      date: '21/5'
    }, {
      name: 'Cornelia',
      date: '3/12'
    }],
    W: [{
      name: 'William',
      date: '6/4'
    }],
    U: [{
      name: 'Ulf',
      date: '11/4'
    }, {
      name: 'Ulla',
      date: '4/7'
    }, {
      name: 'Ulrik',
      date: '5/8'
    }, {
      name: 'Ulrika',
      date: '4/7'
    }, {
      name: 'Uno',
      date: '14/8'
    }, {
      name: 'Urban',
      date: '25/5'
    }, {
      name: 'Ursula',
      date: '21/10'
    }],
    Å: [{
      name: 'Åke',
      date: '8/5'
    }, {
      name: 'Åsa',
      date: '12/9'
    }, {
      name: 'Åslög',
      date: '12/9'
    }],
    Ö: [{
      name: 'Örjan',
      date: '9/7'
    }, {
      name: 'Östen',
      date: '26/8'
    }]
  }
};
svs.tickets_giftshop.gift.giftform.date_selector.namesByDateData = namesByDateData;

 })(window);